/*!
 * devextreme-vue
 * Version: 22.2.12
 * Build date: Mon Apr 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-vue
 */

"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DxCalendar = void 0;
var calendar_1 = __importDefault(require("devextreme/ui/calendar"));
var index_1 = require("./core/index");
var DxCalendar = index_1.createComponent({
    props: {
        accessKey: String,
        activeStateEnabled: Boolean,
        cellTemplate: {},
        dateSerializationFormat: String,
        disabled: Boolean,
        disabledDates: [Array, Function],
        elementAttr: Object,
        firstDayOfWeek: {
            type: Number,
            validator: function (v) { return typeof (v) !== "number" || [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].indexOf(v) !== -1; }
        },
        focusStateEnabled: Boolean,
        height: [Function, Number, String],
        hint: String,
        hoverStateEnabled: Boolean,
        isValid: Boolean,
        max: {},
        maxZoomLevel: String,
        min: {},
        minZoomLevel: String,
        name: String,
        onDisposing: Function,
        onInitialized: Function,
        onOptionChanged: Function,
        onValueChanged: Function,
        readOnly: Boolean,
        rtlEnabled: Boolean,
        showTodayButton: Boolean,
        showWeekNumbers: Boolean,
        tabIndex: Number,
        validationError: {},
        validationErrors: Array,
        validationMessageMode: String,
        validationMessagePosition: String,
        validationStatus: String,
        value: {},
        visible: Boolean,
        weekNumberRule: String,
        width: [Function, Number, String],
        zoomLevel: String
    },
    emits: {
        "update:isActive": null,
        "update:hoveredElement": null,
        "update:accessKey": null,
        "update:activeStateEnabled": null,
        "update:cellTemplate": null,
        "update:dateSerializationFormat": null,
        "update:disabled": null,
        "update:disabledDates": null,
        "update:elementAttr": null,
        "update:firstDayOfWeek": null,
        "update:focusStateEnabled": null,
        "update:height": null,
        "update:hint": null,
        "update:hoverStateEnabled": null,
        "update:isValid": null,
        "update:max": null,
        "update:maxZoomLevel": null,
        "update:min": null,
        "update:minZoomLevel": null,
        "update:name": null,
        "update:onDisposing": null,
        "update:onInitialized": null,
        "update:onOptionChanged": null,
        "update:onValueChanged": null,
        "update:readOnly": null,
        "update:rtlEnabled": null,
        "update:showTodayButton": null,
        "update:showWeekNumbers": null,
        "update:tabIndex": null,
        "update:validationError": null,
        "update:validationErrors": null,
        "update:validationMessageMode": null,
        "update:validationMessagePosition": null,
        "update:validationStatus": null,
        "update:value": null,
        "update:visible": null,
        "update:weekNumberRule": null,
        "update:width": null,
        "update:zoomLevel": null,
    },
    model: { prop: "value", event: "update:value" },
    computed: {
        instance: function () {
            return this.$_instance;
        }
    },
    beforeCreate: function () {
        this.$_WidgetClass = calendar_1.default;
        this.$_hasAsyncTemplate = true;
    }
});
exports.DxCalendar = DxCalendar;
exports.default = DxCalendar;
